module.exports = __webpack_public_path__ + "img/placeholder_logo.b133925b.png";